import { DQOIErrorBus } from "./DQOIError";
import { AttachmentBus } from "./AttachmentBus";
import { InvoiceLinesBus } from "./InvoiceLinesBus";
import { v_InvoiceLineItemBus } from "./v_InvoiceLineItemBus";
import { OrderDetailsBus } from "./OrderDetailsBus";
import { v_LocationDetailBus } from "./v_LocationDetailBus";
import { v_DispatchNoteBus } from "./v_DispatchNoteBus";
import { v_DispatchPartsRequestedBus } from "./v_DispatchPartsRequestedBus";
import { v_DispatchPartsOrderedBus } from "./v_DispatchPartsOrderedBus";
import { DispatchCustPartsBus } from "./DispatchCustPartsBus";
import { v_DispatchAssignmentBus } from "./v_DispatchAssignmentBus";
import { v_DispatchLaborBus } from "./v_DispatchLaborBus";
import { v_DispatchEquipmentSvcdBus } from "./v_DispatchEquipmentSvcdBus";
import { v_DispatchAttachmentBus } from "./v_DispatchAttachmentBus";
import { v_QuoteInvoiceBus } from "./v_QuoteInvoiceBus";
import { v_QuoteNoteBus } from "./v_QuoteNoteBus";
import { v_InvoiceEquipmentBus } from "./v_InvoiceEquipmentBus";
import { v_QuoteEquipmentBus } from "./v_QuoteEquipmentBus";
import { v_InvoiceNoteBus } from "./v_InvoiceNoteBus";
import { InvoiceNoteBus } from "./InvoiceNoteBus";
import { VendorReturnDetailBus } from "./VendorReturnDetailBus";
import { VendorReturnBus } from "./VendorReturnBus";
import { OrderBillDetailsBus } from "./OrderBillDetailsBus";
import { OrderBillPaymentsBus } from "./OrderBillPaymentsBus";
import { OrderBillBus } from "./OrderBillBus";
import { VendorCreditBus } from "./VendorCreditBus";
import { VendorCreditItemsBus } from "./VendorCreditItemsBus";
import { ScheduleInvoiceBus } from "./ScheduleInvoiceBus";
import { AdditionalInvoiceData } from "./AdditionalInvoiceData";
import { DispatchAssignmentBus } from "./DispatchAssignmentBus";
import { ScheduleDispatchBus } from "./ScheduleDispatchBus";
import { AdditionalCnstJobData } from "./AdditionalCnstJobData";
import { AdditionalQuoteData } from "./AdditionalQuoteData";
import { AdditionalDispatchData } from "./AdditionalDispatchData";
import { AdditionalOrderData } from "./AdditionalOrderData";
import { AdditionalCnstContractData } from "./AdditionalCnstContractData";
import { RelatedJobBus } from "./RelatedJobBus";
import { TimeDetailBus } from "./TimeDetailBus";
import { TimeForPersonBus } from "./TimeForPersonBus";
import { InvoicePaymentBus } from "./InvoicePaymentBus";
import { TaxCodeBus } from "./TaxCodeBus";
import { CustomerProceduresBus } from "./CustomerProceduresBus";
import { VehicleMaintenanceHistoryBus } from "./VehicleMaintenanceHistoryBus";
import { v_QuoteBus } from "./v_QuoteBus";
import { InvoiceCollectionNotesBus } from "./InvoiceCollectionNotesBus";
import { AssetNotesBus } from "./AssetsTrackingBus";
import { AssetAssignmentHistoryBus } from "./AssetAssignmentHistoryBus";
import { CustomerContactBus } from "./CustomerContactBus";
import { CustomerInvoiceChecklistBus } from "./CustomerInvoiceChecklistBus";
import { CustomerPricingBus } from "./CustomerPricingBus";
import { CustomerInventoryBus } from "./CustomerInventoryBus";
import { BillingCodeRatesBus } from "./BillingCodeRatesBus";
import { CustomerOnbDataBus } from "./CustomerOnbDataBus";
import { CustomerInventoryPMBus } from "./CustomerInventoryPMBus";
import { LocBillingCodeRatesBus } from "./LocBillingCodeRatesBus";
import { LocationInventoryXREFBus } from "./LocationInventoryXREFBus";
import { LocationEquipmentBus } from "./LocationEquipmentBus";
import { EmployHistoryBus } from "./EmployHistory";
import { VehicleBus } from "./VehicleBus";
import { VehicleDocumentBus } from "./VehicleDocumentBus";
import { InventoryThresholdOverrideBus } from "./InventoryThresholdOverrideBus";
import { InventoryLocationXrefBus } from "./InventoryLocationXrefBus";
import { InventorySupplierXrefBus } from "./InventorySupplierXrefBus";
import { InventoryConsumablesBus } from "./InventoryConsumablesBus";
import { InventoryConsMatchesBus } from "./InventoryConsMatchesBus";
import { DispatchQVBus } from "./DispatchQVBus";
import { AdditionalDispatchQVData } from "./AdditionalDispatchQVData";
import { DispatchKudosBus } from "./DispatchKudosBus";
import { DispatchLaborBus } from "./DispatchLaborBus";
import { KudosAndOpportunityBus } from "./KudosAndOpportunityBus";
import { UnionJobRoleXrefBus } from "./UnionJobRoleXrefBus";
import { DispatchCostAdjustmentBus } from "./DispatchCostAdjustmentBus";
import { v_DispatchPartBus } from "./v_DispatchPartBus";
import { InventoryThresholdOverrideBranchBus } from "./InventoryThresholdOverrideBranchBus";
import { LoggedTimeDetailBus } from "./LoggedTimeDetailBus";
import { ClockedTimeEntriesBus } from "./ClockedTimeEntriesBus";
import { TimeOffRequestBus } from "./TimeOffRequestBus";
import { PayrollDeductionBus } from "./PayrollDeductionBus";
import { UnionBenefitsBus } from "./UnionBenefitsBus";
import { ExpenseDetailViewBus } from "./ExpenseDetailViewBus";
import { DispatchAttachmentViewBus } from "./DispatchAttachmentViewBus";
import { VehicleMaintExpenseBus } from "./VehicleMaintExpenseBus";
import { OrderExpenseBus } from "./OrderExpenseBus";
import { MiscExpenseBus } from "./MiscExpenseBus";
import { LabelPrintQueueBus } from "./LabelPrintQueueBus";
import { LocationPricingBus } from "./LocationPricingBus";
import { SubCategoryMarkUpBus } from "./SubCategoryMarkUpBus";
import { CustomerInvoiceBillingCodeBus } from "./CustomerInvoiceBillingCodeBus";
import { TaxLinesBus } from "./TaxLinesBus";
import { CustomerInvoiceBillingCodeMarkupBus } from "./CustomerInvoiceBillingCodeMarkupBus";
import { InventoryPartNbrsBus } from "./InventoryPartNbrsBus";
import { DispatchContAdjustmentBus } from "./DispatchContAdjustmentBus";
import { DispatchCurrCostAdjustmentBus } from "./DispatchCurrCostAdjustmentBus";
import { DispatchBTDAdjustmentBus } from "./DispatchBTDAdjustmentBus";
import { DispatchSixZeroSixAdjustmentBus } from "./DispatchSixZeroSixAdjustmentBus";
import { DispatchPMCompleteAdjustmentBus } from "./DispatchPMCompleteAdjustmentBus";
import { DispatchEquipmentAdjustmentBus } from "./DispatchEquipmentAdjustmentBus";
import { DispatchRefTrackingBus } from "./DispatchRefTrackingBus";
import { LocationContractNotesBus } from "./LocationContractNotesBus";
import { OrderNotesBus } from "./OrderNotesBus";
import { SubletBus } from "./SubletBus";
import { RentalBus } from "./RentalBus";
import { BuyOutsBus } from "./BuyOutsBus";
import { LaborRateBus } from "./LaborRateBus";
import { ComponentBus } from "./ComponentBus";
import { RefrigerantBus } from "./RefrigerantBus";
import { BidRefrigerantBus } from "./BidRefrigerent";
import { BidComponentBus } from "./BidComponentBus";
import { BidEquipmentBus } from "./BidEquipmentBus";
import { v_InventoryXferHistoryBus } from "./v_InventoryXferHistoryBus";
import { v_InventoryCostHistoryBus } from "./v_InventoryCostHistoryBus";
import { BidsheetSummaryBus } from "./BidsheetSummaryBus";
import { BidCopperBus } from "./BidCopperBus";
import { BidInsulationBus } from "./BidInsulationBus";
import { BidPipeSaddleBus } from "./BidPipeSaddleBus";
import { BidSaddleSizeBus } from "./BidSaddleSize";
import { DispatchSOWAdjustmentBus } from "./DispatchSOWAdjustmentBus";
import { BidPipeLiquidBus } from "./BidPipeLiquidBus";
import { DispatchCallbackBus } from "./DispatchCallbackBus";
import { BidInsulatedPipesBus } from "./BidInsulatedPipes";
import { CondensateDrainLinesBus } from "./CondensateDrainLinesBus";
import { BidPipeSaddlesBus } from "./BidPipeSaddlesBus";
import { LaborBreakdownBus } from "./LaborBreakdownBus";
import { LaborBlendBus } from "./LaborBlendBus";
import { EquipmentSalesBuyoutsBus } from "./EquipmentSalesBuyoutsBus";
import { BidHVACBus } from "./BidHVACBus";
import { BidsheetpartsBus } from "./BidsheetPartsBus";
import { VehicleNotesBus } from "./VehicleNotesBus";
import { SystemEventSubscriptionsBus } from "./SystemEventSubscriptionsBus";
import { EquipmentData } from "./equipmentData";
import { BidsheetEquipmentBus } from "./BidsheetEquipmentBus";
import { BidEquipmentTabBus } from "./BidEquipmentTabBus";
import { ZebraPrinterStatusDto } from "./ZebraPrinterStatusDto";
import { v_EmployeeBus } from "./v_EmployeeBus";
import { CreditMemoWidgetUser } from "./CreditMemoWidgetUser";
import { InventoryThresholdOverrideAlternative } from "./InventoryThresholdOverrideAlternative";
import { v_InvoiceCheckListAttachmentBus } from "./v_InvoiceCheckListAttachmentBus";
import { v_InvoiceCheckListNoteBus } from "./v_InvoiceCheckListNoteBus";

export class BusinessObjectFactory
{
    public static Create(code: string, data: any = null) : any {
        if (code === 'AdditionalInvoiceData') {
            return new AdditionalInvoiceData(data);
        }
        else if (code === 'DQOIErrorBus') {
            return new DQOIErrorBus(data);
        }
        else if (code === 'AttachmentBus') {
            return new AttachmentBus(data);
        }
        else if (code === 'v_InvoiceLineItemBus') {
            return new v_InvoiceLineItemBus(data);
        }
        else if (code === 'InvoiceLinesBus') {
            return new InvoiceLinesBus(data);
        }
        else if (code === 'OrderDetailsBus') {
            return new OrderDetailsBus(data);
        }
        else if (code === 'v_LocationDetailBus') {
            return new v_LocationDetailBus(data);
        }
        else if (code === 'v_DispatchNoteBus') {
            return new v_DispatchNoteBus(data);
        }
        else if (code === 'OrderNotesBus') {
            return new OrderNotesBus(data);
        }
        else if (code === 'VehicleNotesBus') {
            return new VehicleNotesBus(data);
        }
        else if (code === 'VehicleNotesBus') {
            return new VehicleNotesBus(data);
        }
        else if (code === 'v_DispatchPartsRequestedBus') {
            return new v_DispatchPartsRequestedBus(data);
        }
        else if (code === 'v_DispatchPartBus') {
            return new v_DispatchPartBus(data);
        }
        else if (code === 'v_DispatchPartsOrderedBus') {
            return new v_DispatchPartsOrderedBus(data);
        }
        else if (code === 'DispatchCustPartsBus') {
            return new DispatchCustPartsBus(data);
        }
        else if (code === 'v_DispatchAssignmentBus') {
            return new v_DispatchAssignmentBus(data);
        }
        else if (code === 'v_InvoiceCheckListAttachmentBus') {
            return new v_InvoiceCheckListAttachmentBus(data);
        }
        else if (code === 'v_InvoiceCheckListNoteBus') {
            return new v_InvoiceCheckListNoteBus(data);
        }
        else if (code === 'DispatchAssignmentBus') {
            return new DispatchAssignmentBus(data);
        }
        else if (code === 'v_DispatchLaborBus') {
            return new v_DispatchLaborBus(data);
        }
        else if (code === 'DispatchLaborBus') {
            return new DispatchLaborBus(data);
        }
        else if (code === 'v_DispatchEquipmentSvcdBus') {
            return new v_DispatchEquipmentSvcdBus(data);
        }
        else if (code === 'v_DispatchAttachmentBus') {
            return new v_DispatchAttachmentBus(data);
        }
        else if (code === 'v_QuoteInvoiceBus') {
            return new v_QuoteInvoiceBus(data);
        }
        else if (code === 'v_QuoteNoteBus') {
            return new v_QuoteNoteBus(data);
        }
        else if (code === 'v_InvoiceEquipmentBus') {
            return new v_InvoiceEquipmentBus(data);
        }
        else if (code === 'v_QuoteEquipmentBus') {
            return new v_QuoteEquipmentBus(data);
        }
        else if (code === 'v_InvoiceNoteBus') {
            return new v_InvoiceNoteBus(data);
        }
        else if (code === 'InvoiceNoteBus') {
            return new InvoiceNoteBus(data);
        }
        else if (code === 'VendorReturnBus') {
            return new VendorReturnBus(data);
        }
        else if (code === 'VendorReturnDetailBus') {
            return new VendorReturnDetailBus(data);
        }
        else if (code === 'OrderBillBus') {
            return new OrderBillBus(data);
        }
        else if (code === 'OrderBillDetailsBus') {
            return new OrderBillDetailsBus(data);
        }
        else if (code === 'OrderBillPaymentsBus') {
            return new OrderBillPaymentsBus(data);
        }
        else if (code === 'VendorCreditBus') {
            return new VendorCreditBus(data);
        }
        else if (code === 'VendorCreditItemsBus') {
            return new VendorCreditItemsBus(data);
        }
        else if (code === 'ScheduleInvoiceBus') {
            return new ScheduleInvoiceBus(data);
        }
        else if (code === 'ScheduleDispatchBus') {
            return new ScheduleDispatchBus(data);
        }
        else if (code === "AdditionalCnstContractData") {
            return new AdditionalCnstContractData(data);
        }
        else if (code === "AdditionalCnstJobData") {
            return new AdditionalCnstJobData(data);
        }
        else if (code === "AdditionalDispatchData") {
            return new AdditionalDispatchData(data);
        }
        else if (code === "AdditionalQuoteData") {
            return new AdditionalQuoteData(data);
        }
        else if (code === "AdditionalOrderData") {
            return new AdditionalOrderData(data);
        }
        else if (code === "AdditionalInvoiceData") {
            return new AdditionalInvoiceData(data);
        }
        else if (code === "RelatedJobBus") {
            return new RelatedJobBus(data);
        }
        else if (code === "TimeDetailBus") {
            return new TimeDetailBus(data);
        }
        else if (code === "TimeForPersonBus") {
            return new TimeForPersonBus(data);
        }
        else if (code === "InvoicePaymentBus") {
            return new InvoicePaymentBus(data);
        }
        else if (code === "TaxCodeBus") {
            return new TaxCodeBus(data);
        }
        else if (code === "VehicleMaintenanceHistoryBus") {
            return new VehicleMaintenanceHistoryBus(data);
        }
        else if (code === "AssetNotesBus") {
            return new AssetNotesBus(data);
        }
        else if (code === "TaxCodeBus") {
            return new TaxCodeBus(data);
        }
        else if (code === 'v_QuoteBus') {
            return new v_QuoteBus(data);
        }
        else if (code === 'InvoiceCollectionNotesBus') {
            return new InvoiceCollectionNotesBus(data);
        }
        
        else if (code === 'AssetAssignmentHistoryBus') {
            return new AssetAssignmentHistoryBus(data);
        }
        else if (code === 'CustomerContactBus') {
            return new CustomerContactBus(data);
        }
        else if (code === 'CustomerProceduresBus') {
            return new CustomerProceduresBus(data);
        }
        else if (code === 'CustomerInvoiceChecklistBus') {
            return new CustomerInvoiceChecklistBus(data);
        }

        else if (code === 'CustomerPricingBus') {
            return new CustomerPricingBus(data);
        }
        else if (code === 'SubCategoryMarkUpBus') { 
            return new SubCategoryMarkUpBus(data);
        }
        else if (code === 'LocationPricingBus') {
            return new LocationPricingBus(data);
        }
        else if (code === 'CustomerInventoryBus') {
            return new CustomerInventoryBus(data);
        }
        else if (code === 'BillingCodeRatesBus') {
            return new BillingCodeRatesBus(data);
        }    
        else if (code === 'LocBillingCodeRatesBus') {
            return new LocBillingCodeRatesBus(data);
        }  
        else if (code === 'CustomerOnbDataBus') {
            return new CustomerOnbDataBus(data);
        } 

        else if (code === 'LoggedTimeDetailBus') {
            return new LoggedTimeDetailBus(data);
        } 
        else if (code === 'ClockedTimeEntriesBus') {
            return new ClockedTimeEntriesBus(data);
        }
        else if (code === 'TimeOffRequestBus') {
            return new TimeOffRequestBus(data);
        }
        else if (code === 'PayrollDeductionBus') {
            return new PayrollDeductionBus(data);
        } 
        else if (code === 'UnionBenefitsBus') {
            return new UnionBenefitsBus(data);
        } 
        else if (code === 'SystemEventSubscriptionsBus') {
            return new SystemEventSubscriptionsBus(data);
        }       
        else if (code === 'CustomerInventoryPMBus') {
            return new CustomerInventoryPMBus(data);
        }
        else if (code === 'LocationInventoryXREFBus') {
            return new LocationInventoryXREFBus(data);
        }
        else if (code === 'LocationEquipmentBus') {
            return new LocationEquipmentBus(data);
        }
        else if (code === 'EmployHistoryBus') {
            return new EmployHistoryBus(data);
        }
        else if (code === 'VehicleBus') {
            return new VehicleBus(data);
        }
        else if (code === 'VehicleDocumentBus') {
            return new VehicleDocumentBus(data);
        }
        else if (code === 'InventoryLocationXrefBus') {
            return new InventoryLocationXrefBus(data);
        }
        else if (code === 'InventorySupplierXrefBus') {
            return new InventorySupplierXrefBus(data);
        }
        else if (code === 'InventoryThresholdOverrideBus') {
            return new InventoryThresholdOverrideBus(data);
        }
        else if (code === 'InventoryThresholdOverrideBranchBus') {
            return new InventoryThresholdOverrideBranchBus(data);
        }
        else if (code === 'InventoryPartNbrsBus') {
            return new InventoryPartNbrsBus(data);
        }
        else if (code === 'InventoryConsumablesBus') {
            return new InventoryConsumablesBus(data);
        }
        else if (code === 'InventoryConsMatchesBus') {
            return new InventoryConsMatchesBus(data);
        }
        else if (code === 'DispatchQVBus') {
            return new DispatchQVBus(data);
        }
        else if (code === 'AdditionalDispatchQVData') {
            return new AdditionalDispatchQVData(data);
        }
        else if (code === 'DispatchKudosBus') {
            return new DispatchKudosBus(data);
        }
        else if (code === 'KudosAndOpportunityBus') {
            return new KudosAndOpportunityBus(data);
        }
        else if (code === 'UnionJobRoleXrefBus') {
            return new UnionJobRoleXrefBus(data);
        }
        else if (code === 'DispatchContAdjustmentBus') {
            return new DispatchContAdjustmentBus(data);
        }
        else if (code === 'DispatchCostAdjustmentBus') {
            return new DispatchCostAdjustmentBus(data);
        }
        else if (code === 'DispatchCurrCostAdjustmentBus') {
            return new DispatchCurrCostAdjustmentBus(data);
        }
        else if (code === 'DispatchSOWAdjustmentBus') {
            return new DispatchSOWAdjustmentBus(data);
        }
        else if (code === 'DispatchBTDAdjustmentBus') {
            return new DispatchBTDAdjustmentBus(data);
        }
        else if (code === 'DispatchSixZeroSixAdjustmentBus') {
            return new DispatchSixZeroSixAdjustmentBus(data);
        }
        else if (code === 'DispatchEquipmentAdjustmentBus') {
            return new DispatchEquipmentAdjustmentBus(data);
        }
        else if (code === 'DispatchPMCompleteAdjustmentBus') {
            return new DispatchPMCompleteAdjustmentBus(data);
        }
        else if (code === 'ExpenseDetailViewBus') {
            return new ExpenseDetailViewBus(data);
        }
        else if (code === 'DispatchAttachmentViewBus') {
            return new DispatchAttachmentViewBus(data);
        }
        else if (code === 'VehicleMaintExpenseBus') {
            return new VehicleMaintExpenseBus(data);
        }

        else if (code === 'OrderExpenseBus') {
            return new OrderExpenseBus(data);
        }

        else if (code === 'MiscExpenseBus') {
            return new MiscExpenseBus(data);
        }
        else if (code === 'LabelPrintQueueBus') {
            return new LabelPrintQueueBus(data);
        }
        else if (code === 'TaxLinesBus') {
            return new TaxLinesBus(data);
        }
        else if (code === 'CustomerInvoiceBillingCodeBus') {
            return new CustomerInvoiceBillingCodeBus(data);
        }
        else if (code === 'CustomerInvoiceBillingCodeMarkupBus') {
            return new CustomerInvoiceBillingCodeMarkupBus(data);
        }
        else if (code === 'DispatchRefTrackingBus') {
            return new DispatchRefTrackingBus(data);
        }
        else if (code === 'LocationContractNotesBus') {
            return new LocationContractNotesBus(data);
        }
        else if (code === 'SubletBus') {
            return new SubletBus(data);
        }
        else if (code === 'RentalBus') {
            return new RentalBus(data);
        }
        else if (code === 'BuyOutsBus'){
            return new BuyOutsBus(data);
        }
        else if (code === 'LaborRateBus'){
            return new LaborRateBus(data);
        }
        else if (code === 'ComponentBus'){
            return new ComponentBus(data);
        }
        else if (code === 'ComponentBusBidsheet'){
            return new BidComponentBus(data);
        }
        else if (code === 'RefrigerantBus'){
            return new RefrigerantBus(data);
        }
        else if (code === 'BidRefrigerantBus'){
            return new BidRefrigerantBus(data);
        }
        else if (code === 'BidEquipmentBus'){
            return new BidEquipmentBus(data);
        }
        else if (code === 'v_InventoryXferHistoryBus') {
            return new v_InventoryXferHistoryBus(data);
        }
        else if (code === 'BidsheetSummaryBus') {
            return new BidsheetSummaryBus(data);
        }
        else if (code === 'CopperBus') {
            return new BidCopperBus(data);
        }
        else if (code === 'BidInsulationBus') {
            return new BidInsulationBus(data);
        }
        else if (code === 'BidSaddleBus') {
            return new BidPipeSaddleBus(data);
        }
        else if (code === 'BidSaddleSizeBus') {
            return new BidSaddleSizeBus(data);
        }
        else if (code === 'v_InventoryCostHistoryBus') {
            return new v_InventoryCostHistoryBus(data);
        }
        else if (code === 'BidPipeLiquidBus') {
            return new BidPipeLiquidBus(data);
        }
        else if (code === 'DispatchCallbackBus') {
            return new DispatchCallbackBus(data);
        }
        else if (code === 'BidInsulatedPipesBus') {
            return new BidInsulatedPipesBus(data);
        }
        else if (code === 'CondensateDrainLinesBus') {
            return new CondensateDrainLinesBus(data);
        }
        else if (code === 'BidPipeSaddlesBus') {
            return new BidPipeSaddlesBus(data);
        }
        else if (code === 'LaborBreakdownBus') {
            return new LaborBreakdownBus(data);
        }
        else if (code === 'LaborBlendBus') {
            return new LaborBlendBus(data);
        }
        else if (code === 'EquipmentSalesBuyoutsBus') {
            return new EquipmentSalesBuyoutsBus(data);
        }
        else if (code === 'BidHVACBus') {
            return new BidHVACBus(data);
        }
        else if (code === 'BidsheetpartsBus') {
            return new BidsheetpartsBus(data);
        }
        else if (code === 'EquipmentData'){
            return new EquipmentData(data);
        }
        else if (code === 'BidsheetEquipmentBus') {
            return new BidsheetEquipmentBus(data);
        }
        else if (code === 'BidEquipmentTabBus') {
            return new BidEquipmentTabBus(data);
        }
        else if (code === 'ZebraPrinterStatusDto') {
            return new ZebraPrinterStatusDto(data);
        }
        else if (code === 'v_EmployeeBus') {
            return new v_EmployeeBus(data);
        }
        else if (code === 'CreditMemoWidgetUser') {
            return new CreditMemoWidgetUser(data);
        }
        else if (code === 'InventoryThresholdOverrideAlternatives') {
            return new InventoryThresholdOverrideAlternative(data);
        }
    }
} 
